import bootstrap from './bootstrap';
import { noop } from './utility/Utilities';

bootstrap(noop);
